var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lack-of-rest-alert-tooltip-text z-10 aisea-text-14-400-white pl-1"},[_c('div',{staticClass:"alert-title"},[_vm._v("過去48時間以内に以下のアラートが発生している人数を表示しています。")]),_c('div',{staticClass:"alert-item"},[_vm._v("・1日間のうち最長の休息時間が6時間未満")])])
}]

export { render, staticRenderFns }